<template>
  <div class="form-single-fragment" style="position: relative;">
    <el-form ref="AddPaIndexModel" :model="formData" class="full-width-input" :rules="rules" style="width: 100%;"
      label-width="100px" :size="defaultFormItemSize" label-position="right" @submit.native.prevent>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="分组" prop="PaIndexModel.code" v-if="formData.PaIndexModel.code!=='pa_salary'&&formData.PaIndexModel.code!=='pa_work'&&formData.PaIndexModel.gcode!=='pa_work'">
            <el-select class="input-item" v-model="formData.PaIndexModel.code"
                       :clearable="true" filterable placeholder="分组" :loading="AddPaIndexModel.code.impl.loading"
                       @visible-change="AddPaIndexModel.code.impl.onVisibleChange">
              <el-option v-for="item in AddPaIndexModel.code.impl.dropdownList" :key="item.id" :value="item.id" :label="item.name" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="名称" prop="PaIndexModel.name">
            <el-input class="input-item" v-model="formData.PaIndexModel.name"
              :clearable="true" placeholder="名称"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="校验规则" prop="PaIndexModel.verifyRule">
            <el-select class="input-item" v-model="formData.PaIndexModel.verifyRule"
                       :clearable="true" filterable placeholder="校验规则" :loading="AddPaIndexModel.verifyRule.impl.loading"
                       @visible-change="AddPaIndexModel.verifyRule.impl.onVisibleChange">
              <el-option v-for="item in AddPaIndexModel.verifyRule.impl.dropdownList" :key="item.id" :value="item.id" :label="item.name" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-show="formData.PaIndexModel.gcode==='pa_work'">
          <el-form-item label="指标定义" prop="PaIndexModel.pa_work.indexDefinition">
            <el-input class="input-item" v-model="formData.PaIndexModel.pa_work.indexDefinition"
                      type="textarea" autosize :clearable="true" placeholder="指标定义"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24" v-show="formData.PaIndexModel.gcode==='pa_work'">
          <el-form-item label="目标值" prop="PaIndexModel.pa_work.indexTargetValue">
            <el-input class="input-item" v-model="formData.PaIndexModel.pa_work.indexTargetValue"
                      type="textarea" autosize :clearable="true" placeholder="目标值"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24" v-show="formData.PaIndexModel.gcode==='pa_work'">
          <el-form-item label="权重" prop="PaIndexModel.pa_work.indexWeightValue">
            <el-input-number class="input-item" v-model="formData.PaIndexModel.pa_work.indexWeightValue"
                             :clearable="true" :precision="2" :step="0.01" :max="1"
                             placeholder="权重"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="formData.PaIndexModel.gcode==='pa_work'&&formData.PaIndexModel.code==='work_lv_a_rate'">
          <el-form-item label="满分线(%)" prop="PaIndexModel.pa_work.fullScoreLine">
            <el-input-number class="input-item" v-model="formData.PaIndexModel.pa_work.fullScoreLine"
                             :clearable="true" :max="100"
                             placeholder="满分线(%)"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="formData.PaIndexModel.gcode==='pa_work'&&formData.PaIndexModel.code==='work_lv_a_rate'">
          <el-form-item label="扣分系数" prop="PaIndexModel.pa_work.indexWeightValue">
            <el-input-number class="input-item" v-model="formData.PaIndexModel.pa_work.deductionFactor"
                             :clearable="true" :max="100"
                             placeholder="扣分系数"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24" v-show="formData.PaIndexModel.gcode==='pa_work'">
          <el-form-item label="计分规则" prop="PaIndexModel.pa_work.indexScoreRule">
            <el-input class="input-item" v-model="formData.PaIndexModel.pa_work.indexScoreRule"
                      type="textarea" autosize :clearable="true" placeholder="计分规则"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="校验规则" prop="PaIndexModel.verifyRule">
            <el-select class="input-item" v-model="formData.PaIndexModel.verifyRule"
                       :clearable="true" filterable placeholder="校验规则" :loading="AddPaIndexModel.verifyRule.impl.loading"
                       @visible-change="AddPaIndexModel.verifyRule.impl.onVisibleChange">
              <el-option v-for="item in AddPaIndexModel.verifyRule.impl.dropdownList" :key="item.id" :value="item.id" :label="item.name" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="排序" prop="PaIndexModel.sort">
            <el-input-number class="input-item" v-model="formData.PaIndexModel.sort"
              :clearable="true"
              placeholder="排序"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="描述" prop="PaIndexModel.detail" v-show="formData.PaIndexModel.gcode!=='pa_work'">
            <el-input class="input-item" v-model="formData.PaIndexModel.detail"
              :clearable="true" placeholder="描述"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="备注" prop="PaIndexModel.remark">
            <el-input class="input-item" v-model="formData.PaIndexModel.remark"
              :clearable="true" placeholder="备注"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-collapse :span="24" v-model="activeNames">
            <el-collapse-item title="高级配置" name="advanced">
              <el-col :span="24">
                <el-form-item label="启用条件" prop="PaIndexModel.enableCondition">
                  <el-input class="input-item" v-model="formData.PaIndexModel.enableCondition"
                            :clearable="true" placeholder="启用条件"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="输入变量" prop="PaIndexModel.inputVariable">
                  <el-input class="input-item" v-model="formData.PaIndexModel.inputVariable"
                            :clearable="true" placeholder="输入变量"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="参数变量" prop="PaIndexModel.paramVariable">
                  <el-input class="input-item" v-model="formData.PaIndexModel.paramVariable"
                            :clearable="true" placeholder="参数变量"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="24">
              <el-form-item label="指标值" prop="PaIndexModel.indexValue">
                  <el-input class="input-item" v-model="formData.PaIndexModel.indexValue"
                            :clearable="true" placeholder="本指标值"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="计算公式" prop="PaIndexModel.evalFormula">
                  <el-input class="input-item" v-model="formData.PaIndexModel.evalFormula"
                            :clearable="true" placeholder="计算公式"
                  />
                </el-form-item>
              </el-col>
            </el-collapse-item>
          </el-collapse>
        </el-col>
        <el-col :span="24">
          <el-row class="no-scroll flex-box" type="flex" justify="end">
            <el-button type="primary" :size="defaultFormItemSize" :plain="true"
              @click="onCancel(false)">
              取消
            </el-button>
            <el-button type="primary" :size="defaultFormItemSize" :disabled="!checkPermCodeExist('AddPaIndexModel:AddPaIndexModel:add')"
              @click="onAddClick()">
              新增
            </el-button>
          </el-row>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
/* eslint-disable-next-line */
import { findTreeNode, findTreeNodePath, findItemFromList } from '@/utils';
/* eslint-disable-next-line */
import rules from '@/utils/validate.js';
/* eslint-disable-next-line */
import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
/* eslint-disable-next-line */
import { uploadMixin, statsDateRangeMixin } from '@/core/mixins';
/* eslint-disable-next-line */
import { PaIndexModelController, DictionaryController } from '@/api';

export default {
  name: 'AddPaIndexModel',
  props: {
    // 是否支持级联操作
    supportCascadeAdd: {
      type: String,
      default: '0'
    },
    // 级联操作数据
    rowData: {
      type: Object
    },
    pid: {
      default: undefined
    },
    type: {
      default: undefined
    },
    gcode: {
      default: undefined
    }
  },
  mixins: [uploadMixin, statsDateRangeMixin],
  data () {
    return {
      activeNames: [],
      formData: {
        PaIndexModel: {
          id: undefined,
          pid: this.pid,
          type: this.type,
          code: undefined,
          gcode: this.gcode,
          name: undefined,
          detail: undefined,
          remark: undefined,
          sort: 1,
          enableCondition: undefined,
          inputVariable: undefined,
          paramVariable: undefined,
          indexValue: undefined,
          verifyRule: undefined,
          evalFormula: undefined,
          taskCode: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          deletedFlag: undefined,
          paIndexGroup: {
          },
          isDatasourceInit: false,
          pa_work: {
            indexDefinition: '',
            indexTargetValue: '',
            indexWeightValue: 0,
            fullScoreLine: 0,
            deductionFactor: 0,
            indexScoreRule: ''
          }
        }
      },
      rules: {
        'PaIndexModel.name': [
          {required: true, message: '请输入名称', trigger: 'blur'}
        ],
        'PaIndexModel.type': [
          {required: true, message: '请选择分组', trigger: 'blur'}
        ],
        'PaIndexModel.code': [
          {required: true, message: '请选择分组', trigger: 'blur'}
        ],
        'PaIndexModel.verifyRule': [
          {required: true, message: '请选择校验规则', trigger: 'blur'}
        ]
      },
      AddPaIndexModel: {
        formFilter: {
        },
        formFilterCopy: {
        },
        type: {
          impl: new DropdownWidget(this.loadTypeDropdownList)
        },
        code: {
          impl: new DropdownWidget(this.loadCodeDropdownList)
        },
        verifyRule: {
          impl: new DropdownWidget(this.loadVerifyRuleDropdownList)
        },
        BtnDiv: {
          isInit: false
        },
        isInit: false
      }
    }
  },
  methods: {
    onCancel (isSuccess, data) {
      if (this.observer != null) {
        this.observer.cancel(isSuccess, data);
      }
    },
    /**
     * 类型下拉数据获取函数
     */
    loadTypeDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {groupCode: 'pa_index_model_type'};
        DictionaryController.dictSysDictByGroupCode(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 编码下拉数据获取函数
     */
    loadCodeDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {groupCode: 'pa_index_model_code'};
        DictionaryController.dictSysDictByGroupCode(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 校验规则下拉数据获取函数
     */
    loadVerifyRuleDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {groupCode: 'pa_index_model_verify_rule'};
        DictionaryController.dictSysDictByGroupCode(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 类型选中值改变
     */
    onTypeValueChange (value) {
    },
    /**
     * 更新添加指标模型
     */
    refreshAddPaIndexModel (reloadData = false) {
      if (!this.AddPaIndexModel.isInit) {
        // 初始化下拉数据
        this.AddPaIndexModel.code.impl.onVisibleChange(true).catch(e => {});
        this.AddPaIndexModel.verifyRule.impl.onVisibleChange(true).catch(e => {});
      }
      this.AddPaIndexModel.isInit = true;
    },
    /**
     * 新增
     */
    onAddClick () {
      this.$refs.AddPaIndexModel.validate((valid) => {
        if (!valid) return;
        // 如果是级联表格的添加或者编辑弹窗
        if (this.supportCascadeAdd === '1') {
          let formData = {
            typeDictMap: findItemFromList(this.AddPaIndexModel.type.impl.dropdownList, this.formData.PaIndexModel.type, 'id'),
            ...this.formData.PaIndexModel
          };
          this.onCancel(true, formData);
          return;
        }
        let detail = this.formData.PaIndexModel.detail;
        if (this.formData.PaIndexModel.gcode === 'pa_work') {
          if (this.formData.PaIndexModel.pa_work.indexWeightValue > 1) {
            this.$message.error('操作失败,权重不能大于1');
            return;
          }
          detail = this.formData.PaIndexModel.pa_work;
        }
        let params = {
          paIndexModelDto: {
            pid: this.pid,
            type: this.formData.PaIndexModel.type,
            code: this.formData.PaIndexModel.code,
            gcode: this.formData.PaIndexModel.gcode,
            name: this.formData.PaIndexModel.name,
            detail: detail,
            remark: this.formData.PaIndexModel.remark,
            sort: this.formData.PaIndexModel.sort,
            enableCondition: this.formData.PaIndexModel.enableCondition,
            paramVariable: this.formData.PaIndexModel.paramVariable,
            indexValue: this.formData.PaIndexModel.indexValue,
            verifyRule: this.formData.PaIndexModel.verifyRule,
            evalFormula: this.formData.PaIndexModel.evalFormula,
            taskCode: this.formData.PaIndexModel.taskCode,
            inputVariable: this.formData.PaIndexModel.inputVariable
          }
        };

        PaIndexModelController.add(this, params).then(res => {
          this.$message.success('新增成功');
          this.onCancel(true);
        }).catch(e => {});
      });
    },
    initFormData () {
    },
    /**
     * 重置表单数据
     */
    resetFormData () {
      this.formData = {
        PaIndexModel: {
          id: undefined,
          pid: undefined,
          type: undefined,
          code: undefined,
          gcode: undefined,
          name: undefined,
          detail: undefined,
          remark: undefined,
          sort: undefined,
          enableCondition: undefined,
          inputVariable: undefined,
          paramVariable: undefined,
          indexValue: undefined,
          verifyRule: undefined,
          evalFormula: undefined,
          taskCode: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          deletedFlag: undefined,
          paIndexGroup: {
          },
          isDatasourceInit: false,
          pa_work: {
            indexDefinition: '',
            indexTargetValue: '',
            indexWeightValue: 0,
            fullScoreLine: 0,
            deductionFactor: 0,
            indexScoreRule: ''
          }
        }
      }
    },
    formInit () {
      this.refreshAddPaIndexModel();
    }
  },
  computed: {
  },
  mounted () {
    // 初始化页面数据
    this.formInit();
    // 初始化级联数据
    if (this.supportCascadeAdd === '1' && this.rowData != null) {
      this.formData.PaIndexModel = {
        ...this.rowData
      }
    }
  },
  watch: {
  }
}
</script>
